<template>
  <div>
    <v-row v-if="productSelected.technologies.length > 0">
      <v-col class="mt-2 pt-2">
        <v-divider></v-divider>
        <label class="text-h6 text-weight-black mt-4">Mais Informações</label>
      </v-col>
    </v-row>
    <v-row v-if="productSelected.technologies.length > 0">
      <v-col class="">
        <v-row v-for="tech in productSelected.technologies" :key="tech.name">
          <v-col cols="12" xs="4" md="2">
            <v-img
              :lazy-src="tech.image"
              max-width="88"
              class="mx-auto"
              :src="tech.image"
            ></v-img>
          </v-col>
          <v-col class="px-4">
            <p class="text-justify">
              {{ tech.description }}
            </p>
            <p class="text-justify">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Urna
              nunc id cursus metus aliquam eleifend mi. Duis tristique
              sollicitudin nibh sit amet commodo nulla facilisi.
            </p>
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    productSelected: {},
  },
};
</script>
